import { GlobalUtils } from "src/app/shared/global-utils";

export class FormDataCreateCustomerAcess {
  public async build(element: any): Promise<FormData> {
    let {
      type,
      email,
      partners,
      systemId, 
      fileType,
      password,
      acessDescription,
      fileAttachment,
      createdAt,
      customers,
      paymentMethod,
      pixKey
    } = element;

    let formData = new FormData();

  
    if (typeof fileAttachment === 'string' && fileAttachment.toLowerCase().includes(';base64')) {
      const mimeType = fileAttachment.substring(
        fileAttachment.indexOf(':') + 1,
        fileAttachment.indexOf(';')
      );
      const extension = mimeType.split('/')[1] || 'bin'; 
    
      const base64Data = fileAttachment.split(',')[1];
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
    
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
    
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: mimeType });
    
      formData.append('fileAttachment', new File([blob], `filename.${extension}`));
    } else if (fileAttachment instanceof File) {
      formData.append('fileAttachment', fileAttachment, fileAttachment.name);
    }
    


    if (systemId) {
      formData.append('systemId', systemId); 
    } else {
      throw new Error('O campo "systemId" é obrigatório e não foi definido.');
    }

     formData.append('createdAt', createdAt ? new Date(createdAt).toISOString() : new Date().toISOString());


    formData.append('type', type);
    
    if (partners) {
      formData.append('partners', partners);
    }

    if (customers) {
      formData.append('customers', customers);
    }

    formData.append('fileType', fileType);
    formData.append('password', password);
    formData.append('acessDescription',acessDescription);
    formData.append('email', email);

    if (paymentMethod) {
      formData.append('paymentMethod', paymentMethod);
    }
    if (pixKey) {
      formData.append('pixKey', pixKey);
    }

    // Log para debug
    console.log('FormData sendo enviado:', {
      type,
      email,
      partners,
      systemId,
      fileType,
      password,
      acessDescription
    });

    return formData;
  }
}
